import React from 'react';
import GoogleMapReact from 'google-map-react';
import { G_KEY } from "../../config";

const OriginMarker = () => (
    <div style={{
        position: 'absolute',
        transform: 'translate(-50%, -50%)'
    }}>
        <i
            className="text-danger fas fa-map-marker-alt"
            style={{fontSize:'24px'}}
        ></i>
    </div>
);

const Maps = (props) => {
    return(
        <div style={{ height: '200px', width: '100%', borderRadius: '12px' }}>
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: G_KEY,
                    language: "id",
                    region: "id"
                }}
                center={{
                    lat: props.originCoordinate.latitude,
                    lng: props.originCoordinate.longitude
                }}
                yesIWantToUseGoogleMapApiInternals
                defaultZoom={props.zoom ? props.zoom : 14}
                key={1}
            >
                <OriginMarker
                    lat={props.originCoordinate.latitude}
                    lng={props.originCoordinate.longitude}
                    text="My Marker"
                />
            </GoogleMapReact>
        </div>
    );
};
export default Maps;